import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import axios from "../helpers/axios";
import Layout from "../components/global/Layout";
import PartTable from "../components/parts/PartTable";
import imagen from "../assets/grey_style.gif";

const Parts = () => {

  const  site = process.env.REACT_APP_SITE;
  const company = process.env.REACT_APP_CODE_COMPANY;
  const dbs_host = process.env.REACT_APP_DBS_HOST;

  const [parts, setParts] = useState([]);
  const [uriAttrs, setUriAttrs] = useState("");

  // filtering
  const [filters, setFilters] = useState([]);

  // paging
  const [count, setCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(200);

  // sorting
  const [sorting, setSorting] = useState([
    { columnName: "estimated_time", direction: "asc" },
  ]);

  const [toggle, setToggle] = useState(false)


  const [errorMessage, setErrorMessage] = useState('');

  const loadData = () => {
    const attrs = {};

    // filtering
    filters.forEach((filter) => {
      if (filter.columnName === "rfdcno") {
        attrs["search"] = filter.value.toUpperCase();
      } else if (filter.columnName === "invoice") {
        attrs["invoice__name"] = filter.value.toUpperCase();
      } else {
        attrs[filter.columnName] = filter.value.toUpperCase();
      }
    });

    if (attrs["status"] === undefined) {
      attrs["max_status"] = 49;
    }

    // paging
    attrs["limit"] = pageSize;
    attrs["offset"] = currentPage * pageSize;

    // sorting
    const { direction, columnName } = sorting[0];
    attrs["ordering"] = (direction === "desc" ? "-" : "") + columnName;

    const listAttrs = [];
    for (let key in attrs) {
      listAttrs.push(
        `${encodeURIComponent(key)}=${encodeURIComponent(attrs[key])}`
      );
    }

    const uriAttrs = listAttrs.join("&");

    const docName = attrs['search'];
    setUriAttrs(uriAttrs);

    if( docName ){
      setErrorMessage('');
      if( docName.length > 8){
        setToggle(true);
        axios.get(`/api/parts/?${uriAttrs}`).then((response) => {
          const { data } = response;

          let parts_results = data.results;

          // Leo documentos del tracking
            if( data.results.length === 0){
              setCount(0);
              setParts([]);
              setToggle(false);
            }
            else{
              let data_0 = data.results[0]
              let doc_rfdcno = data_0.rfdcno.slice(0,9);
              axios.post(`${dbs_host}dbs/public/api/v1/getBackorder?company=${company}&document=${doc_rfdcno}`)
              .then(({ status, data:data_dbs }) => {
                if (status === 200 && data_dbs.message === "Success") {
                  if(data_dbs.payload.children){
                    if(data_dbs.payload.children.length > 100 ){
                      alert('Entra a detalle de documento para actualizar')
                    }else{
  
                      const lista_estatus = {'X':50, 'F':50, 'C':80}
                      const list_docsu = ['X', 'F', 'C']
  
                      data_dbs.payload.children.map(( child )=>{
                        const status = lista_estatus[child.docsu];
                        const number_document = child.rfdcno; 
  
                        child.parts.map((part_dbs) => {
                          
                          const part_dbs_clean = part_dbs.pano20.replaceAll(" ","");
  
                          let parts_index = parts_results.findIndex( part => part.rfdcno === number_document && part.pano20 === part_dbs_clean);
                          if(parts_index >= 0){
  
                            if( list_docsu.includes(child.docsu)){
  
                              let part_app = parts_results[parts_index]
                              if (part_app.status !== child.status){
                                axios.patch(`/api/parts/${part_app.id}/`, {
                                  'status': status,
                                });
                                parts_results.splice(parts_index,1);
                              }
  
                            }
                          }
                          });
                          
                      })
                      
                    }
                  }
                  setCount(parts_results.length)
                  setParts(parts_results)
                  setToggle(false);
                }
                else{
                  console.log('No encontro parte en api');
                  if (status === 500 && data_dbs.message === "El documento no existe o ya fue facturado") {
                    parts_results.map( part => {
                      if( part.spqty === 0){
                        axios.patch(`/api/parts/${part.id}/`, {
                          'status': 80,
                          'docsu': 'C'
                        });
                      }else{
                        axios.patch(`/api/parts/${part.id}/`, {
                          'status': 50,
                          'docsu': 'X'
                        });
                      }
                    })
                    setCount(0);
                    setParts([]);
                    setToggle(false);
                  }
                }
              })
              .catch(function (error) {
                if (error.response) {
                  setErrorMessage(error.response.data.error);
                  if (error.response.data.error == 'El documento no existe o ya fue facturado'){
                    parts_results.map( part => {
                      if( part.spqty === 0){
                        console.log('Cancelar por error de peticion a dbs');
                        axios.patch(`/api/parts/${part.id}/`, {
                          'status': 80,
                          'docsu': 'C'
                        });
                      }else{
                        console.log('Facturar por error de peticion dbs');
                        axios.patch(`/api/parts/${part.id}/`, {
                          'status': 50,
                          'docsu': 'X'
                        });
                      }
                    })

                    setCount(0);
                    setParts([]);
                    setToggle(false);
                  }

                } else if (error.request) {
                  console.log(error.request);
                  setToggle(false);
                }
              });
            }
        });

      }else{

        axios.get(`https://tracking.${site}/api/parts/?${uriAttrs}`).then((response) => {

          const { data } = response;
          setCount(data.count);
          setParts(data.results);
        });

      }
    }else{
        axios.get(`https://tracking.${site}/api/parts/?${uriAttrs}`).then((response) => {
          const { data } = response;
          setCount(data.count);
          setParts(data.results);
        });
    }

  };

  useEffect(() => {
    loadData();
  }, [filters, pageSize, currentPage, sorting]);

  return (
    <Layout>
      {toggle && (
              <img src={imagen} style={{
                position:"fixed",
                top: "0",
                bottom: "0",
                left: "0",
                right: "0",
                width:"150px",
                margin:"auto",
                zIndex: "1111",
                display: "block"
              }}/>
      )}

      <div
        className="container"
        style={{
          padding: "2rem",
        }}
      >
        <div className="level">
          <div className="level-left">
            <div className="level-item">
              <h1 className="title is-2">Partes</h1>
            </div>
          </div>
        </div>
      </div>

      {errorMessage && (
        <p style={{color: 'red'}}> {errorMessage} </p>
      )}

      <div
        className="container mt-5"
        style={{
          padding: "2rem",
          backgroundColor: "#f5f5f5",
          borderRadius: "10px",
        }}
      >
        <PartTable
          parts={parts}
          actions={[
            <div className="field has-addons mb-0 mr-3">
              <p className="control">
                <a
                  href={`${process.env.REACT_APP_BACKEND_HOST}api/parts/spreadsheet/?${uriAttrs}`}
                  className="button is-light"
                >
                  <span className="icon is-small">
                    <FontAwesomeIcon icon={["far", "file-excel"]} />
                  </span>
                </a>
              </p>
            </div>,
          ]}
          hasFilters
          filters={filters}
          setFilters={setFilters}
          hasPaging
          count={count}
          pageSize={pageSize}
          setPageSize={setPageSize}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          hasSorting
          sorting={sorting}
          setSorting={setSorting}
          onChange={() => {
            loadData();
          }}
        />
      </div>
    </Layout>
  );
};

export default Parts;
